var _linearGradient, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSourceCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d10bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f01580"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(0 2 -2 0 16 14)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#a"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(0 2 -2 0 22 14)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#a"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(0 2 -2 0 28 14)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#a"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(0 24 -24 0 32 32)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#a"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(0 7.7525 -4.569 0 19.9191 36.0005)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#a"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(0 7.7155 -4.2175 0 44.3496 36.0005)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#a"
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(0 12.839 -5.441 0 32.5001 36.5)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 16c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-2.001v.001z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22 16c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-2.001v.001z",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m28 16c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-2.001v.001z",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m51 8h-38c-2.757 0-5 2.243-5 5v38c0 2.757 2.243 5 5 5h38c2.757 0 5-2.243 5-5v-38c0-2.757-2.243-5-5-5zm-38 2h38c1.654 0 3 1.346 3 3v5h-44v-5c0-1.654 1.346-3 3-3zm38 44h-38c-1.654 0-3-1.346-3-3v-31h44v31c0 1.654-1.346 3-3 3z",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m23.1711 28.248-7.137 6.245c-.435.38-.684.93-.684 1.508s.249 1.127.684 1.508l7.137 6.244 1.317-1.505-7.137-6.251 7.137-6.244z",
    fill: "url(#f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5291 28.285-1.397 1.431 6.434 6.288-6.434 6.281 1.397 1.431 6.434-6.281c.389-.38.604-.89.604-1.434s-.215-1.054-.604-1.434z",
    fill: "url(#g)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m27.0591 48.661 1.882.678 9-25-1.882-.678z",
    fill: "url(#h)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceCode);
export default __webpack_public_path__ + "static/media/source-code.3ccadb8de2793b695a6854b7f16ccc8d.svg";
export { ForwardRef as ReactComponent };